import type { FuseNavItemType, FuseFlatNavItemType } from '../core/FuseNavigation/types/FuseNavItemType';

class FuseNavigationHelper {
	static flattenNavigation(navigation: FuseNavItemType[], parentId: string | null = null): FuseFlatNavItemType[] {
		let flatNavigation: FuseFlatNavItemType[] = [];

		navigation.forEach((item) => {
			const { children, ...itemWithoutChildren } = item;
			const flatItem: FuseFlatNavItemType = {
				...itemWithoutChildren,
				parent: parentId,
				order: item.id,
				children: children?.map((child) => child.id),
			};

			flatNavigation.push(flatItem);

			if (children) {
				flatNavigation = flatNavigation.concat(this.flattenNavigation(children, item.id));
			}
		});

		return flatNavigation;
	}

	static unflattenNavigation(flatNavigation: FuseFlatNavItemType[]): FuseNavItemType[] {
		const navigation: FuseNavItemType[] = [];
		const lookup: { [key: string]: FuseNavItemType } = {};

		flatNavigation.forEach((item) => {
			lookup[item.id] = { ...item, children: [] };
		});

		flatNavigation.forEach((item) => {
			if (item.parent) {
				const parent = lookup[item.parent];
				if (parent) {
					if (!parent.children) {
						parent.children = [];
					}
					parent.children.push(lookup[item.id]);
				}
			} else {
				navigation.push(lookup[item.id]);
			}
		});

		return navigation;
	}
}

export default FuseNavigationHelper;
